<template>
  <el-dialog
    :title="isCreate ? '新增门店' : '编辑门店'"
    :visible="true"
    :before-close="closeForm"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="130px"
      class="demo-ruleForm"
    >
      <agentVendorShop
        @select="selectHandler"
        :showShop="false"
        v-if="isCreate"
      />
      <agentVendorShop
        @select="selectHandler"
        :initData="selectedAvs"
        @init="initHandler"
        :showShop="false"
        v-else
      />

      <el-form-item label="门店名" prop="shopName">
        <el-input v-model.trim="ruleForm.shopName"></el-input>
        {{ ruleForm.shopid }}
      </el-form-item>

      <el-form-item label="照片">
        <el-upload
          class="avatar-uploader"
          action="/api/shared/upload"
          :show-file-list="false"
          :on-success="handleAvatarSuccess"
          :before-upload="beforeAvatarUpload"
        >
          <img v-if="imageUrl" :src="imageUrl" class="avatar" />
          <i v-else class="avatar-uploader-icon" style="font: 10px"
            >点击上传128*128</i
          >
        </el-upload>
      </el-form-item>
      <el-form-item label="开门时间" prop="shopOpenTime">
        <!-- <el-input v-model.trim="ruleForm.machineStartTime"></el-input> -->
        <el-time-select
          placeholder="开门时间"
          v-model="ruleForm.shopOpenTime"
          :picker-options="{
            start: '00:00',
            step: '00:05',
            end: '24:00'
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="关门时间" prop="shopCloseTime">
        <el-time-select
          placeholder="关门时间"
          v-model="ruleForm.shopCloseTime"
          :picker-options="{
            start: '00:00',
            step: '00:05',
            end: '24:00'
          }"
        >
        </el-time-select>
      </el-form-item>
      <el-form-item label="所在城市" prop="shopCity">
        <el-select v-model="ruleForm.shopCity" placeholder="请选择">
          <el-option
            v-for="(item, index) in CITY_ENUM"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="地址" prop="shopAddress">
        <el-input
          v-model.trim="ruleForm.shopAddress"
          style="width: 352px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="经度" prop="shopLongitude">
        <el-input
          v-model.trim="ruleForm.shopLongitude"
          style="width: 252px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="纬度" prop="shopLatitude">
        <el-input
          v-model.trim="ruleForm.shopLatitude"
          style="width: 252px;"
        ></el-input>
      </el-form-item>
      <el-form-item label="是否下线">
        <el-switch v-model="ruleForm.shopOffline"></el-switch>
      </el-form-item>
      <el-form-item label="是否可以预约">
        <el-switch v-model="ruleForm.canReserve"></el-switch>
      </el-form-item>

      <el-form-item label="预约时长（分钟）">
        <el-input-number
          :min="5"
          v-model.trim="ruleForm.reserveMinutes"
        ></el-input-number>
      </el-form-item>

      <el-form-item label="联系电话" prop="shopTelephone">
        <el-input
          style="width: 252px;"
          v-model.trim="ruleForm.shopTelephone"
          placeholder="默认平台400电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="描述" prop="shopDescription">
        <el-input
          style="width: 300px;"
          v-model.trim="ruleForm.shopDescription"
          type="textarea"
          :rows="2"
        ></el-input>
      </el-form-item>
      <el-form-item label="备注" prop="shopRemark">
        <el-input
          v-model.trim="ruleForm.shopRemark"
          style="width: 300px;"
          type="textarea"
          :rows="2"
          placeholder="填写保洁人员信息"
        ></el-input>
      </el-form-item>
      <div class="align-center">
        <el-button type="primary" @click="submitForm(true)">确定</el-button>
        <el-button type="primary" v-if="isCreate" @click="submitForm(false)"
          >连续添加</el-button
        >
        <el-button @click="closeForm()">取消</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import enumObject from "../../../plugins/enum";
//import { mapGetters } from "vuex";
import agentVendorShop from "@/components/layout/agentVendorShop";

export default {
  components: {
    agentVendorShop
  },
  props: ["isCreate", "shopInfo"],
  data() {
    return {
      imageUrl:
        this.shopInfo && this.shopInfo.shopImageUrl
          ? "/api/shared/getImage?ossFileKey=" + this.shopInfo.shopImageUrl
          : "",

      // vendorsList: [],
      // projectList: [],
      ruleForm: {
        id: 0,
        shopid: "",
        shopName: "",
        shopCity: "",
        shopAddress: "",
        shopLongitude: "",
        shopLatitude: "",
        //shopOwner: "",
        //shopOwnerName: "",
        vendorid: "",
        vendorName: "",
        agentid: "",
        agentName: "",
        // projectid : "",
        shopDescription: "",
        shopImageUrl: "",
        shopOpenTime: "",
        shopCloseTime: "",
        shopOffline: false,
        reserveMinutes: 0,
        canReserve: false,
        shopTelephone: "",
        shopRemark: ""
      },
      rules: {
        shopid: [{ required: true, message: "请输入有效的商铺名称" }],
        shopCity: [{ required: true, message: "请输入城市名称" }],
        shopAddress: [{ required: true, message: "请输入商铺地址" }],
        shopLongitude: [
          { required: true, message: "请输入商铺经度" },
          {
            validator: (rule, value, callback) => {
              if (
                !/^-?((0|1?[0-7]?[0-9]?)(([.][0-9]+)?)|180(([.][0]+)?))$/.test(
                  value
                )
              ) {
                return callback(new Error("请输入正确的经度"));
              } else {
                return callback();
              }
            }
          }
        ],
        shopLatitude: [
          { required: true, message: "请输入商铺纬度" },
          {
            validator: (rule, value, callback) => {
              if (
                !/^-?((0|[1-8]?[0-9]?)(([.][0-9]+)?)|90(([.][0]+)?))$/.test(
                  value
                )
              ) {
                return callback(new Error("请输入正确的纬度"));
              } else {
                return callback();
              }
            }
          }
        ],

        shopOpenTime: [
          { required: true, message: "请输入开店时间，格式00:00" }
        ],
        shopCloseTime: [
          { required: true, message: "请输入关店时间，格式00:00" }
        ],

        vendorid: [{ required: true, message: "请输入加盟商名称" }],
        agentid: [{ required: true, message: "请输入有效总代的名称" }],
        // projectid: [{ required: true, message: "请输入项目名称" }],
        shopDescription: [{ required: true, message: "请输入商铺描述" }]
      },
      agentListForPrompt: [],
      vendorListForPrompt: [],
      //shopListForPrompt: [],
      selectedAvs: {}
    };
  },
  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
    },

    initHandler(x) {
      console.log("initHandler", x);
      this.ruleForm.agentid = x.selectedAgent.agentid;
      this.ruleForm.vendorid = x.selectedVendor.vendorid;
    },
    submitForm(closeDialog) {
      console.log(closeDialog);
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          let queryModel = {
            id: this.ruleForm.id,
            shopid: this.ruleForm.shopid,
            shopName: this.ruleForm.shopName,
            shopCity: this.ruleForm.shopCity,
            shopAddress: this.ruleForm.shopAddress,
            shopLongitude: this.ruleForm.shopLongitude,
            shopLatitude: this.ruleForm.shopLatitude,
            shopOwner: this.ruleForm.vendorid,
            agentid: this.ruleForm.agentid,

            //projectid: this.ruleForm.projectid,
            shopDescription: this.ruleForm.shopDescription,
            shopImageUrl: this.ruleForm.shopImageUrl,
            shopOpenTime: this.ruleForm.shopOpenTime,
            shopCloseTime: this.ruleForm.shopCloseTime,
            shopOffline: this.ruleForm.shopOffline,
            shopTelephone: this.ruleForm.shopTelephone,
            shopRemark: this.ruleForm.shopRemark,
            canReserve: this.ruleForm.canReserve,
            reserveMinutes: this.ruleForm.reserveMinutes
          };

          if (this.ruleForm.canReserve && this.ruleForm.reserveMinutes < 5) {
            this.$message.error("预约时长不得小于5分钟!");
            return;
          }

          console.log("queryModel", queryModel);
          let key = this.isCreate ? "新增门店" : "编辑门店";
          this.$axios(this.$urlMapping[key], {
            data: queryModel
            // eslint-disable-next-line no-unused-vars
          }).then(result => {
            this.$notifySuccess();
            this.$getAllShopIDName(); //刷新全局数据
            if (closeDialog) {
              this.$emit("closeForm");
            } else {
              this.$refs["ruleForm"].resetFields();
            }
            this.$emit("handleUpdate");
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccess(res, file) {
      console.log(res);
      this.imageUrl = URL.createObjectURL(file.raw);
      if (res.code == 0) {
        this.ruleForm.shopImageUrl = res.result.key;
      } else {
        this.$notify.error({
          title: "消息",
          message: "上传图片失败"
        });
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return isJPG && isLt2M;
    },

    closeForm() {
      this.$emit("closeForm");
    }
  },
  computed: {
    CITY_ENUM() {
      return enumObject.CITY_ENUM.filter(ele => ele.value != "");
    }
  },

  mounted() {
    if (!this.isCreate) {
      console.log("edit");
      console.log(this.shopInfo);

      //this.ruleForm.shopid = ["a1155", "v1336", "s1337"];
      this.ruleForm.shopid = this.shopInfo.shopid;
      this.ruleForm.vendorid = this.shopInfo.shopOwner;
      this.ruleForm.agentid = this.shopInfo.agentid;

      this.ruleForm.shopName = this.$getShopName(this.shopInfo.shopid);
      this.ruleForm.vendorName = this.$getVendorName(this.shopInfo.shopOwner);
      this.ruleForm.agentName = this.$getAgentName(this.shopInfo.agentid);

      this.ruleForm.id = this.shopInfo.id;
      this.ruleForm.shopCity = this.shopInfo.shopCity;
      this.ruleForm.shopAddress = this.shopInfo.shopAddress;
      this.ruleForm.shopLongitude = this.shopInfo.shopLongitude;
      this.ruleForm.shopLatitude = this.shopInfo.shopLatitude;
      this.ruleForm.shopDescription = this.shopInfo.shopDescription;
      this.ruleForm.shopImageUrl = this.shopInfo.shopImageUrl;
      this.ruleForm.shopOpenTime = this.shopInfo.shopOpenTime;
      this.ruleForm.shopCloseTime = this.shopInfo.shopCloseTime;
      this.ruleForm.shopOffline = this.shopInfo.shopOffline;
      this.ruleForm.shopTelephone = this.shopInfo.shopTelephone;
      this.ruleForm.shopRemark = this.shopInfo.shopRemark;
      this.ruleForm.canReserve = this.shopInfo.canReserve;
      this.ruleForm.reserveMinutes = this.shopInfo.reserveMinutes;

      this.selectedAvs = {
        selectedAgentid: this.shopInfo.agentid,
        selectedVendorid: this.shopInfo.shopOwner,
        selectedShopid: this.shopInfo.shopid
      };
    }
  }
};
</script>

<style lang="less" scoped>
// .el-select {
//   width: 202px;
// }
/deep/ .el-input,
.el-form-item__content,
.el-textarea,
.el-input__inner,
.el-date-editor.el-input {
  // width: 252px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 12px;
  color: #8c939d;
  width: 68px;
  height: 68px;
  line-height: 68px;
  text-align: center;
}
.avatar {
  width: 68px;
  height: 68px;
  display: block;
}
</style>
